<template>
<div style="height:100%;">
    <v-card class="fill-height print" height="100%">
    <v-toolbar
      flat
      height="auto"
      class="elevation-5"
    >
    <v-row>
        <v-col sm="12" md="6" lg="6" xl="6" cols="12" xs="12">
            <v-toolbar-title style="white-space: pre-wrap; word-wrap: break-word;" id="reportHeader">
                <h4>Загрузка файлов отчета</h4>
                <h6 class="text--disabled no-print">Загрузите отчеты системы ТК</h6>
            </v-toolbar-title>
        </v-col>
    </v-row>
    </v-toolbar>
    <v-card-text style="padding:10px;">
        <v-row style="padding:20px;">
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
                <v-file-input
    v-model="files"
    color="primary"
    :accept="accept"
    label="Загрузка файлов"
    placeholder="Выберите файлы отчета"
    prepend-icon="mdi-paperclip"
    outlined
    :disabled="upload"
    :show-size="1000"
  >
    <template v-slot:selection="{ index, text }">
      <v-chip
        v-if="index < 2"
        color="primary"
        dark
        label
        small
      >
        {{ text }}
      </v-chip>

      <span
        v-else-if="index === 2"
        class="text--disabled mx-2"
      >
        +{{ files.length - 2 }} файлов
      </span>
    </template>
  </v-file-input>
            </v-col>
            <v-col cols="12" sm="12" xl="6" lg="6" md="6">
                <v-select
                color="primary"
                prepend-icon="mdi-web"
                v-model="cardSystem"
                :items="cardSystems"
                label="Система ТК"
                outlined
                required
                :disabled="upload"
                >
                </v-select>
            </v-col>
        </v-row>
        <v-row class="mx-5">
            <v-btn
            block
            x-large
            :loading="upload"
            color="primary"
            @click="UploadFiles"
            :disabled="!files || files.length === 0">
            <v-icon
              dark
              x-large
            >
              mdi-cloud-upload
            </v-icon>
                <span class="px-2">Загрузить</span>
            </v-btn>
        </v-row>
    </v-card-text>
    </v-card>
</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data: () => ({
    cardSystem: 'Опти-24',
    cardSystems: ['Опти-24', 'Shell', 'Neste Oil', 'Роснефть'],
    files: []
  }),
  computed: {
    ...mapState({
      upload: state => state.transactions.upload
    }),
    accept: function () {
      switch (this.cardSystem) {
        case 'Опти-24': return 'application/xml'
        case 'Shell': return '.csv'
        case 'Neste Oil' : return '.csv'
        case 'Роснефть' : return 'application/vnd.ms-excel'
      }
      return ''
    }
  },
  mounted: () => {
    document.title = 'Загрузить отчет - ATK Web'
  },
  methods: {
    ...mapActions('transactions', {
      uploadOpti24TransactionToServer: 'uploadOpti24TransactionToServer',
      uploadShellTransactionToServer: 'uploadShellTransactionToServer',
      uploadNesteTransactionToServer: 'uploadNesteTransactionToServer',
      uploadRosneftTransactionToServer: 'uploadRosneftTransactionToServer'
    }),
    UploadFiles () {
      switch (this.cardSystem) {
        case
          'Опти-24': this.uploadOpti24TransactionToServer(this.files)
          break
        case
          'Shell': this.uploadShellTransactionToServer(this.files)
          break
        case
          'Neste Oil' : this.uploadNesteTransactionToServer(this.files)
          break
        case
          'Роснефть' : this.uploadRosneftTransactionToServer(this.files)
          break
      }
    }
  }
}
</script>
